<template>
  <div id="navigation">
    <p class="logo">
      <img
          src="@/assets/img/header_logo.png"
          alt="CCS">
    </p>
    <el-menu
        ref="menu"
        :default-active="activeNaviIndex"
        :router="true"
        mode="horizontal"
        @select="select">
      <template v-for="nav in navigation">
        <BaseNavigationItem v-if="$isFunctionShown(nav.funcId) && loggedIn"
            :key="nav.index"
            :item="nav" />
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as define from '@/define'

import BaseNavigationItem from '@/components/molecules/BaseNavigationItem'

export default {
  name: 'BaseNavigation',
  components: {
    BaseNavigationItem
  },
  props: {
    activeNaviIndex: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isPopoverVisible: false
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      accountId: (state) => state.accountId,
      loggedIn: (state) => state.loggedIn,
      fromAcnLogin: state => state.fromAcnLogin
    }),
    // ナビゲーションバー 構成リスト
    navigation () {
      return [
        { title: 'ダッシュボード', icon: 'fas fa-chart-area', route: '/dashboard' },
        { title: '注文', funcId: define.PermissionKeys.ORDER, index: 'order', icon: 'fas fa-paste',
          subItems: [
            { title: '注文一覧', funcId: define.PermissionKeys.Order.LIST, route: '/order' },
            { title: '臨時出荷指図依頼一覧', funcId: define.PermissionKeys.Order.EXTRA_EXPORT_LIST, route: '/extraExport' }
          ]
        },
        { title: '顧客 / ポイント', funcId: define.PermissionKeys.CUSTOMER, index: 'customer', icon: 'fas fa-user',
          subItems: [
            { title: '顧客一覧', funcId: define.PermissionKeys.Customer.LIST, route: '/customer' },
            { title: 'ポイント履歴一覧', funcId: define.PermissionKeys.Customer.POINT_HISTORY, route: '/point' }
          ]
        },
        { title: 'ポイント設定', funcId: 'menu_point', index: 'point', icon: 'fas fa-award',
          subItems: [
            { title: 'ポイント設定', funcId: 'pointSetting_list', route: '/pointsetting' },
            { title: 'ポイント基本設定', funcId: 'pointBasicSetting_detail', route: '/pointbasicsetting' },
            { title: '顧客ランクマスタ', funcId: 'customerRank_list', route: '/customerrank' }
          ]
        },
        { title: '商品', funcId: 'menu_product', index: 'product', icon: 'fas fa-shopping-cart',
          subItems: [
            // { title: 'ささげ情報', funcId: 'sasage_list', route: '/product' },
            { title: '商品一覧', funcId: 'product_list', route: '/product' },
            { title: 'マスタ管理', funcId: 'master', index: 'master',
              subItems: [
                { title: 'ブランドマスタ', funcId: 'master_brand_list', route: '/master/brand' },
                { title: 'カラーマスタ', funcId: 'master_color_list', route: '/master/color' },
                { title: 'カラーグループマスタ', funcId: 'master_color_group_list', route: '/master/colorGroup' },
                { title: 'サイズマスタ', funcId: 'master_size_list', route: '/master/size' },
                { title: 'サイズグループマスタ', funcId: 'master_size_group_list', route: '/master/sizeGroup' },
                { title: 'レーベルマスタ', funcId: 'master_label_list', route: '/master/label' },
                { title: '部位マスタ', funcId: 'master_part_list', route: '/master/part' },
                { title: '洗濯絵マスタ', funcId: 'master_washing_list', route: '/master/washing' },
                { title: 'コードマスタ', funcId: 'master_code_list', route: '/master/code' },
                { title: '構成品マスタ', funcId: 'master_component_list', route: '/master/n/component' }
              ]
            },
            { title: '受注数一覧', funcId: 'product_order_quantity_list', route: '/orderQuantity' }
          ]
        },
        { title: '在庫', funcId: define.PermissionKeys.STOCK, index: 'stock', icon: 'fas fa-cubes',
          subItems: [
            { title: 'EC在庫一覧', funcId: define.PermissionKeys.Stock.EcStock.LIST, route: '/ecStock' },
            { title: 'EC在庫アラート設定一覧', funcId: define.PermissionKeys.Stock.Alert.LIST, route: '/stockAlert' }
          ]
        },
        { title: 'ファイル入出力', funcId: define.PermissionKeys.FILEIO, index: 'fileIo', icon: 'fas fa-download',
          subItems: [
            { title: 'ダウンロード', funcId: define.PermissionKeys.FileIo.DOWNLOAD, route: '/download' },
            { title: 'アップロード', funcId: define.PermissionKeys.FileIo.UPLOAD, route: '/upload' }
          ]
        },
        { title: '各種設定', funcId: define.PermissionKeys.SETTINGS, index: 'settings', icon: 'fas fa-tools',
          subItems: [
            { title: 'メールテンプレート一覧', funcId: 'mail_template_list', route: '/settings/mailTemplate' },
            { title: '物流カレンダーメンテナンス', funcId: 'master_ship_holiday_list', route: '/ship' }
          ]
        },
        { title: 'アカウント', funcId: define.PermissionKeys.ACCOUNT, index: 'account', icon: 'fas fa-id-card',
          subItems: [
            { title: 'アカウント一覧', funcId: define.PermissionKeys.Account.Account.LIST, route: '/account' },
            { title: 'サイトロール一覧', funcId: define.PermissionKeys.Account.SiteRole.LIST, route: '/siterole' },
            { title: '権限ロール一覧', funcId: define.PermissionKeys.Account.PermissionRole.LIST, route: '/permissionrole' }
          ]
        },
        { title: 'システム', funcId: 'menu_system', index: 'system', icon: 'fas fa-cog',
          subItems: [
            { title: 'ログ確認', funcId: 'log', route: '/log' },
            { title: 'バッチ再実行', funcId: 'batch', route: '/batch' },
            { title: 'API', funcId: 'api', route: '/forTest' },
            { title: 'Validation', funcId: 'validation', route: '/validation' }
          ]
        },
        { title: this.accountId, class: 'nav_account_setting', index: 'accountSetting', icon: 'fas fa-user-circle',
          subItems: [
            { title: 'パスワード変更', route: '/password' },
            { title: 'ログアウト', click: this.logOut }
          ]
        }
      ]
    }
  },
  watch: {
    loggedIn: function (loggedIn) {
      if (!loggedIn) {
        this.isPopoverVisible = false
      }
    }
  },
  methods: {
    select (index, indexPath, item) {
      /*
       * 編集破棄確認ダイアログが表示されるときNaviBarのactive要素だけ移動してしまうため、
       * 実際に画面が移動するまでは元のactive要素を維持する.
       */
      this.$refs.menu.activeIndex = this.activeNaviIndex
    },
    logOut () {
      // 「/login/acn」からのログインであればに「/login/acn」に返す
      this.$router.push({ path: this.fromAcnLogin ? '/login/acn' : '/login', query: { redirect: this.$router.history.current.path } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/organisms/BaseNavigation.vue